import { render, staticRenderFns } from "./ShallowTreeView.vue?vue&type=template&id=25d1f452&lang=pug"
import script from "./ShallowTreeView.vue?vue&type=script&lang=js"
export * from "./ShallowTreeView.vue?vue&type=script&lang=js"
import style0 from "./ShallowTreeView.vue?vue&type=style&index=0&id=25d1f452&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports